import * as OktaAuth from "@okta/okta-auth-js";

const TOKEN_MANAGER_KEY = "my_id_token";

const orgUrl = "https://integrator-9939340.okta.com/";
const clientId = "0oaw51hk1hqijZEH2697";
const redirectUri = `${window.location.protocol}//${window.location.host}/`;

class OktaClient {
  private okta: any;

  constructor(orgUrl: String, clientId: String, redirectUri: String) {
    this.okta = new OktaAuth({
      url: orgUrl,
      clientId: clientId,
      redirectUri: redirectUri,
      tokenManager: {
        autoRefresh: true,
      },
    });
  }

  obtainValidToken(): Promise<any> {
    if (this.hasValidToken()) {
      return Promise.resolve(this.getToken());
    } else {
      return this.refreshToken();
    }
  }

  getToken(): any {
    return this.okta.tokenManager.get(TOKEN_MANAGER_KEY);
  }

  hasValidToken(): boolean {
    const token = this.getToken();
    return token && token.expiresAt * 1000 > Date.now();
  }

  refreshToken(): any {
    return this.okta.tokenManager.refresh(TOKEN_MANAGER_KEY);
  }

  getAuthorizationHeader(): string {
    const idToken = this.getToken() && this.getToken().idToken;
    return idToken ? `Bearer ${idToken}` : null;
  }

  signOut(): void {
    this.okta.tokenManager.clear();
  }
}

const client = new OktaClient(orgUrl, clientId, redirectUri);

export default client;
